import React, { useState, useEffect, useMemo } from "react";
// import "./analytics.css";
import SideCard from "../../../components/Card/SideCard";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { exportTableToPDF } from "../../../../utils/pdfExportUtil";
import { i18n } from "../../private/languageSelector";
import { InvoicesTable } from "../invoices-table/InvoicesTable";
import { useInvoicesUIContext } from "../InvoicesUIContext";
import { cloneDeep } from "lodash";
import { INVOICE_TABLE_ATTRIBUTES } from "../../../../helpers/constants";
import { getUserByToken } from "../../../modules/Auth/_redux/authCrud";
import * as usersActions from "../../../../_redux/users/usersActions";
import * as productActions from "../../../../_redux/products/productsActions";
import * as invoiceActions from "../../../../_redux/invoices/invoicesActions";
import * as storesActions from "../../../../_redux/stores/storeActions";
import PageNavigator from "../../../components/pagination/PageNavigator";
import FiltersDialog from "../../analytics/filters-dialog/FiltersDialog";
import moment from "moment";
// import FilterDialogeNew from "./FilterDialogeNew";
import { InvoiceStore } from "../invoice-create-dialog/InvoiceStore";
import { InvoiceMobileDialog } from "../invoice-pdf/InvoiceMobileDialog";
import { InvoicesDeleteDialog } from "../invoices-delete-dialog/InvoicesDeleteDialog";
import SendPdfInvoiceDialog from "../send-invoice-pdf/sendPDFInvoiceDialog";
import axios from "axios";
import SubscriptionDialog from "../../company/company-edit-Dialog/SubscriptionDialog";
import ViewLogsModal from "../invoice-view-logs-modal/ViewLogsModal";
import JSZip from "jszip";
import toast from "react-hot-toast";
import CustomSearch from "../../../components/searchBar/CustomSearch";
const InvoiceFilterPage = () => {
  const dispatch = useDispatch();
  const [allStores, setAllStores] = useState("");
  const [allUsers, setAllUsers] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedTitle, setSelectedTitle] = useState(i18n("INVOICES.AllInvoices"));
  //eslint-disable-next-line
  const [tableType, setTableType] = useState("salesByTime");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [invoiceLogsLimit, setInvoiceLogsLimit] = useState(10);
  const [allInvoiceStatus, setAllInvoiceStatus] = useState("");

  // const [sortAt, setSortAt] = useState("invoiceData.invoiceNumber");
  // const [sortAt, setSortAt] = useState("created_at");
  const [sortAt, setSortAt] = useState("invoiceData.invoiceDate");
  const [sortOrder, setSortOrder] = useState("desc");
  const [timeRange, setTimeRange] = useState({ start: null, end: null });
  //eslint-disable-next-line
  const [timeZone, setTimeZone] = useState("Asia/Riyadh");
  //eslint-disable-next-line
  const [edit, setEdit] = useState(false);
  const [openStoreDialog, setOpenStoreDialog] = useState(false);
  const [showInvoiceMobileDialog, setShowInvoiceMobileDialog] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [showShareModal, setShowShareModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewLogsModal, setShowViewLogsModal] = useState(false);
  const [message, setMessage] = useState();
  const [emailMessage, setEmailMessage] = useState();
  const [showExportOptionsDropdown, setShowExportOptionsDropdown] = useState(false);
  const [showExportConfirmationModal, setShowExportConfirmationModal] = useState(false);
  const [showWaitModal, setShowWaitModal] = useState(false);
  const { openFiltersDialog } = useSelector((state) => state.analytics);

  const invoicesUIContext = useInvoicesUIContext();
  const invoicesUIProps = useMemo(() => {
    return {
      ids: invoicesUIContext.ids,
      setIds: invoicesUIContext.setIds,
      queryParams: invoicesUIContext.queryParams,
      newInvoiceButtonClick: invoicesUIContext.newInvoiceButtonClick,
      setQueryParams: invoicesUIContext.setQueryParams,
    };
  }, [invoicesUIContext]);

  const [tableFields, setTableFields] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [showSearchInput, setShowSearchInput] = useState(false);

  const {
    stores,
    productFilterState,
    totalCount,
    refundCount,
    salesCount,
    currentState,
    invoice,
    invoiceLogs,
    invoiceLogsCount,
    totalLogsCount,
  } = useSelector(
    (state) => ({
      users: state?.users?.entities,
      filter: state?.invoices?.filterOn,
      products: state?.products?.entities,
      stores: state?.stores?.entities,
      productFilterState: state?.products?.productFilterState,
      totalCount: state?.invoices?.allInvoiceCount,
      salesCount: state?.invoices?.salesCount,
      refundCount: state?.invoices?.refundCount,
      userAccess: state?.users?.userAccess,
      currentState: state.invoices,
      invoice: state?.invoices.invoiceForEdit,
      invoiceLogs: state?.invoices?.invoiceLogs,
      invoiceLogsCount: state?.invoices?.invoiceLogsCount,
      totalLogsCount: state?.invoices?.totalLogsCount,
    }),
    shallowEqual,
  );
  useEffect(() => {
    let tableData = cloneDeep([...INVOICE_TABLE_ATTRIBUTES]);
    setTableFields(tableData);

    getUserByToken().then((res) => {
      if (res?.data?.invoiceTableContent?.length) {
        setTableFields([...res.data.invoiceTableContent]);
      }
    });
  }, []);

  useEffect(() => {
    setTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
  }, []);

  const getInvoiceByFilters = () => {
    dispatch(
      invoiceActions.fetchInvoices(
        {
          type: selectedTitle === i18n("INVOICES.AllInvoices") ? undefined : selectedTitle === i18n("INVOICES.Sales") ? "sale" : "refund",
          status: "",
          channel: "",
          store: allStores?.length > 0 && allStores !== "all" ? allStores : "",
          product: "",
          user: allUsers?.length > 0 && allUsers !== "all" ? allUsers : "",
          reportingStatus: allInvoiceStatus?.length > 0 && allInvoiceStatus !== "all" ? allInvoiceStatus : "",
          startDate: startDate,
          endDate: endDate,
          page: page,
          size: limit,
          isPaginated: true,
          sortBy: sortOrder,
          sortAt: sortAt,
          searchText: searchValue,
        },
        invoicesUIProps.queryParams,
      ),
    );
  };
  useEffect(() => {
    getInvoiceByFilters();
    dispatch(
      invoiceActions.setInvoiceFilterState({
        type: selectedTitle === i18n("INVOICES.AllInvoices") ? undefined : selectedTitle === i18n("INVOICES.Sales") ? "sale" : "refund",
        status: "",
        channel: "",
        store: allStores?.length > 0 && allStores !== "all" ? allStores : "",
        product: "",
        user: allUsers?.length > 0 && allUsers !== "all" ? allUsers : "",
        reportingStatus: allInvoiceStatus?.length > 0 && allInvoiceStatus !== "all" ? allInvoiceStatus : "",
        startDate: startDate,
        endDate: endDate,
        sortAt: sortAt,
        sortBy: sortOrder,
        searchText: searchValue,
      }),
    );
    //eslint-disable-next-line
  }, [startDate, endDate, selectedTitle.length, allUsers, allStores, page, limit, sortAt, sortOrder, allInvoiceStatus, searchValue]);

  let startTime = timeRange?.start?.split(":")[0];
  let endTime = timeRange?.end?.split(":")[0];

  useEffect(() => {
    if (startTime !== "undefined" && endTime !== "undefined") {
      dispatch(
        invoiceActions.fetchInvoices(
          {
            type: selectedTitle === i18n("INVOICES.AllInvoices") ? undefined : selectedTitle === i18n("INVOICES.Sales") ? "sale" : "refund",
            status: "",
            channel: "",
            store: allStores?.length > 0 && allStores !== "all" ? allStores : "",
            product: "",
            user: allUsers?.length > 0 && allUsers !== "all" ? allUsers : "",
            reportingStatus: allInvoiceStatus?.length > 0 && allInvoiceStatus !== "all" ? allInvoiceStatus : "",
            startDate: startDate,
            endDate: endDate,
            startTime: startTime,
            endTime: endTime,
            page: page,
            size: limit,
            isPaginated: true,
            sortAt: sortAt,
            sortBy: sortOrder,
          },
          invoicesUIProps.queryParams,
        ),
      );
      dispatch(
        invoiceActions.setInvoiceFilterState({
          type: selectedTitle === i18n("INVOICES.AllInvoices") ? undefined : selectedTitle === i18n("INVOICES.Sales") ? "sale" : "refund",
          status: "",
          channel: "",
          store: allStores?.length > 0 && allStores !== "all" ? allStores : "",
          product: "",
          user: allUsers?.length > 0 && allUsers !== "all" ? allUsers : "",
          reportingStatus: allInvoiceStatus?.length > 0 && allInvoiceStatus !== "all" ? allInvoiceStatus : "",
          startDate: startDate,
          endDate: endDate,
          startTime: startTime,
          endTime: endTime,
          page: page,
          size: limit,
          isPaginated: true,
        }),
      );
    }
    //eslint-disable-next-line
  }, [timeRange]);

  useEffect(() => {
    if (invoiceLogsCount) {
      setInvoiceLogsLimit(invoiceLogsCount);
    }
  }, [invoiceLogsCount]);

  useEffect(() => {
    if (invoice?.company?._id && invoice?._id) {
      dispatch(invoiceActions.getInvoiceLogsById(invoice?.company?._id, invoice?._id, invoiceLogsLimit));
    }
    //eslint-disable-next-line
  }, [showViewLogsModal]);

  useEffect(() => {
    axios.get("api/whoAmI").then((res) => {
      setMessage(res?.data?.companyId?.defaultSms?.messageEnglish);
      setEmailMessage(res?.data?.companyId?.defaultEmail?.messageEnglish);
    });
  }, []);

  const handleSelectStores = (storeIds) => {
    if (storeIds === "all" || storeIds?.length === stores?.length) {
      setAllStores("");
    } else setAllStores(storeIds);
  };
  const handleSelectUsers = (userIds) => {
    if (userIds === "all") {
      setAllUsers("");
    } else setAllUsers(userIds);
  };
  const handleSelectInvoiceStatus = (statusIds) => {
    if (statusIds === "all" || statusIds?.length >= 3) {
      setAllInvoiceStatus("");
    } else setAllInvoiceStatus(statusIds);
  };
  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
  };

  const handleTimeRangeChange = (start, end) => {
    setTimeRange({ start, end });
  };
  const handleSearchInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  const { language } = useSelector((state) => state.auth);

  let titles = [
    {
      label: i18n("INVOICES.AllInvoices"),
      value: totalCount,
    },

    {
      label: i18n("INVOICES.Sales"),
      value: salesCount,
    },
    {
      label: i18n("INVOICES.Refunds"),
      value: refundCount,
    },
  ];

  useEffect(() => {
    dispatch(storesActions.fetchStores()).then(() => {
      dispatch(usersActions.fetchUsers()).then(() => {
        dispatch(productActions.fetchProducts(productFilterState, invoicesUIContext.queryParams));
      });
    });
    // eslint-disable-next-line
  }, [dispatch]);

  const clearFilterhandle = () => {
    setAllStores("all");
    setAllUsers("all");
    setAllInvoiceStatus("all");
    const last30DaysStart = moment().subtract(29, "days");
    setStartDate(last30DaysStart);
    setEndDate(moment());
    localStorage.setItem("startDate", last30DaysStart.toISOString());
    localStorage.setItem("endDate", moment()?.toISOString());
    localStorage.setItem("timeRange", "allDay");
    setSearchValue("");
    setSortAt("invoiceData.invoiceDate");
    setSortOrder("desc");
  };

  const exportOptionsDropdown = () => {
    return (
      <div
        className="dropdown-menu show py-1 mt-1 rounded"
        style={{
          position: "absolute",
          top: "20px",
          left: language === "english" && "-18px",
          right: language === "arabic" && "-18px",
          maxWidth: "220px",
        }}
      >
        <button
          className="dropdown-item px-4 d-flex align-items-start"
          onClick={() => {
            exportTableToPDF("tableToExport", "invoices.pdf");
            setShowExportOptionsDropdown(false);
          }}
        >
          <span>{i18n("Integration.ExportListAsPdf")}</span>
        </button>

        <button
          className="dropdown-item px-4 d-flex align-items-start"
          onClick={() => {
            setShowExportConfirmationModal(true);
            setShowExportOptionsDropdown(false);
          }}
        >
          <span>{i18n("Integration.ExportAsXml")}</span>
        </button>
      </div>
    );
  };

  const handleExportInvoicesAsZipXml = async () => {
    setShowExportConfirmationModal(false);

    try {
      let invoices = currentState?.entities;
      if (invoices?.length === 0) {
        toast.error("No invoices selected");
        return;
      }

      const zip = new JSZip();
      const manifest = [];

      invoices.forEach((invoice) => {
        const invoiceId = invoice?.invoiceNumber;
        const uuid = invoice?.zatca?.uuid;
        const xml = invoice?.zatca?.signedXml;

        if (!xml || !invoiceId || !uuid) return;

        const fileName = `${invoiceId}_${uuid}.xml`;

        // Add XML file
        zip.file(fileName, xml);

        // Push manifest entry
        manifest.push({
          invoiceId,
          uuid,
          fileName,
          validationStatus: invoice?.zatca?.status,
          requestId: invoice?.zatca?.requestId || null,
          submissionDate: invoice?.zatca?.reportedAt || null,
        });
      });

      if (manifest.length === 0) {
        toast.error("No valid invoices found");
        return;
      }

      // Add manifest.json
      zip.file(
        "manifest.json",
        JSON.stringify(
          {
            generatedAt: new Date().toISOString(),
            totalInvoices: manifest.length,
            invoices: manifest,
          },
          null,
          2,
        ),
      );

      const zipBlob = await zip.generateAsync({ type: "blob" });

      const url = window.URL.createObjectURL(zipBlob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `invoices_${Date.now()}.zip`;
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      toast.success("Invoices ZIP generated successfully");
    } catch (error) {
      console.error(error);
      toast.error("Failed to generate ZIP file");
    }
  };

  const handleLoadMoreLogs = () => {
    dispatch(invoiceActions.getInvoiceLogsById(invoice?.company?._id, invoice?._id, invoiceLogsLimit + 10));
  };
  return (
    <>
      {/* create invoice option hidden */}
      {/* <div className="text-right pb-3 invoice-btn-margin" style={{ marginTop: "-1rem" }}>
        {userAccess?.createData ? (
          <button
            type="button"
            className="btn btn-pri btn-sm btn-rounded"
            onClick={() => {
              setEdit(false);
              setOpenStoreDialog(true);
            }}
          >
            <span className="fas fa-plus mr-2" />
            {i18n("INVOICES.TaxInvoice")}
          </button>
        ) : (
          ""
        )}
      </div> */}
      <div className={`d-flex time-card w-100 ${language === "arabic" ? "rtl" : "ltr"}`} style={{ gap: "1.2rem" }}>
        <div className="side-card-wrapper">
          <SideCard
            handleSelectStores={handleSelectStores}
            handleSelectUsers={handleSelectUsers}
            allUser={allUsers}
            allStores={allStores}
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
            page={page}
            limit={limit}
            tableType={tableType}
            onTimeRangeChange={handleTimeRangeChange}
            timeRange={true}
            showFullHeight
            resetFiltersHandler={clearFilterhandle}
            addMarginTop={true}
            handleSelectInvoiceStatus={handleSelectInvoiceStatus}
          />
        </div>

        <div className={`main-content main-content-card-layout ${language === "arabic" ? "pr-4" : "pl-4"}`}>
          <div className="d-flex  invoice-chart" style={{ gap: "1rem" }}>
            {titles.map((title, index) => (
              <div
                key={index}
                className={`card ${selectedTitle === title?.label ? "selected-chart" : ""}`}
                style={{ cursor: "pointer", marginBottom: "1rem", marginRight: "0px" }}
                onClick={() => setSelectedTitle(title?.label)}
              >
                <div className="invoice-card">
                  <h5 className="card-title">{title?.label}</h5>
                  <div>{title?.value}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="card mb-3">
            <div className="card-body p-0 ">
              {/* <h5 className="card-title text-primary" role="button" onClick={() => exportTableToPDF("tableToExport", "invoices.pdf")}>
                {i18n("LandingPage.EXPORT")}
              </h5> */}
              <div className={` d-flex justify-content-between align-items-start ${language === "arabic" ? "rtl" : "ltr"}`}>
                <CustomSearch
                  handleSearchInputChange={handleSearchInputChange}
                  searchValue={searchValue}
                  setSearchValue={setSearchValue}
                  showSearchInput={showSearchInput}
                  setShowSearchInput={setShowSearchInput}
                  placeholder={i18n("INVOICES.SearchByIdOrCustomer")}
                />
                <h5
                  className="card-title text-primary"
                  style={{ position: "relative" }}
                  role="button"
                  onClick={() => setShowExportOptionsDropdown(!showExportOptionsDropdown)}
                >
                  {i18n("LandingPage.EXPORT")}
                </h5>
              </div>

              {showExportOptionsDropdown && exportOptionsDropdown()}
              <div id="tableToExport">
                {/* <Table columns={columns} data={filteredTableData} onSort={handleSort} sortBy={sortBy} sortOrder={sortOrder} /> */}
                <InvoicesTable
                  tableFields={tableFields}
                  page={page}
                  size={limit}
                  getInvoiceByFilters={getInvoiceByFilters}
                  setShowInvoiceMobileDialog={setShowInvoiceMobileDialog}
                  setSelectedId={setSelectedId}
                  setSortAt={setSortAt}
                  setSortBy={setSortOrder}
                  sortAt={sortAt}
                  sortBy={sortOrder}
                />
              </div>
            </div>
            <nav>
              <PageNavigator
                page={page}
                limit={limit}
                handlePageChange={handlePageChange}
                handleLimitChange={handleLimitChange}
                data={currentState?.entities}
              />
            </nav>
            {openFiltersDialog && (
              <FiltersDialog
                handleSelectStores={handleSelectStores}
                handleSelectUsers={handleSelectUsers}
                allUsers={allUsers}
                allStores={allStores}
                startDate={startDate}
                endDate={endDate}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                handleStartDateChange={handleStartDateChange}
                handleEndDateChange={handleEndDateChange}
                page={page}
                limit={limit}
                tableType={tableType}
                onTimeRangeChange={handleTimeRangeChange}
                timeRange={true}
                resetFiltersHandler={clearFilterhandle}
              />
            )}
          </div>
        </div>
      </div>
      <InvoiceStore edit={edit} openStoreDialog={openStoreDialog} setOpenStoreDialog={setOpenStoreDialog} />
      <InvoiceMobileDialog
        id={selectedId}
        show={showInvoiceMobileDialog}
        onHide={() => setShowInvoiceMobileDialog(false)}
        setShowDeleteModal={setShowDeleteModal}
        setShowShareModal={setShowShareModal}
        setShowViewLogsModal={setShowViewLogsModal}
        getInvoiceByFilters={getInvoiceByFilters}
      />
      <SendPdfInvoiceDialog
        id={selectedId}
        secondaryAction={() => {
          setShowShareModal(false);
          setShowInvoiceMobileDialog(false);
        }}
        invoice={invoice}
        smsMessage={message}
        emailMessageFromCompany={emailMessage}
        sendPdfInvoiceDialog={showShareModal}
        setSendPdfInvoiceDialog={setShowShareModal}
      />
      <InvoicesDeleteDialog
        show={showDeleteModal}
        onHide={() => {
          setShowDeleteModal(false);
        }}
      />
      <ViewLogsModal
        show={showViewLogsModal}
        onHide={() => setShowViewLogsModal(false)}
        invoiceData={invoice}
        invoiceLogs={invoiceLogs}
        handleLoadMoreLogs={handleLoadMoreLogs}
        totalLogsCount={totalLogsCount}
      />
      <SubscriptionDialog
        modalWidth={"350px"}
        modalHeight={"185px"}
        modalBackgroundColor={"#FFFFFF"}
        show={showExportConfirmationModal}
        onHide={() => setShowExportConfirmationModal(false)}
        title={i18n("Integration.ExportInvoices")}
        titleWidth={"140px"}
        titleHeight={"20px"}
        titleFontWeight={"700"}
        titleFontSize={"16px"}
        titleLineHeight={"20px"}
        titleColor={"#333333"}
        message={i18n("Integration.ExportConfirmationText")}
        messageWidth={"320px"}
        messageHeight={"44px"}
        messageFontSize={"16px"}
        messageFontWeight={"400"}
        messageLineHeight={"21.79px"}
        messageColor={"#333333"}
        primaryLabel={i18n("SubscriptionModals.CANCEL")}
        primaryAction={() => setShowExportConfirmationModal(false)}
        primaryLabelWidth={"55px"}
        primaryLabelHeight={"20px"}
        primaryLabelFontWeight={"700"}
        primaryLabelFontSize={"14px"}
        primaryLabelLineHeight={"20px"}
        primaryLabelColor={"#828282"}
        secondaryAction={handleExportInvoicesAsZipXml}
        // secondaryAction={() => {
        //   setShowWaitModal(true);
        //   setShowExportConfirmationModal(false);
        // }}
        secondaryLabel={i18n("LandingPage.EXPORT")}
        secondaryLabelWidth={"75px"}
        secondaryLabelHeight={"20px"}
        secondaryLabelFontWeight={"700"}
        secondaryLabelFontSize={"14px"}
        secondaryLabelLineHeight={"20px"}
        secondaryLabelColor={"#2D9CDB"}
        isCenteredOnMobile
      />
      <SubscriptionDialog
        modalWidth={"350px"}
        modalHeight={"185px"}
        modalBackgroundColor={"#FFFFFF"}
        show={showWaitModal}
        onHide={() => setShowWaitModal(false)}
        title={i18n("Integration.GeneratingXMLFiles")}
        titleWidth={"140px"}
        titleHeight={"20px"}
        titleFontWeight={"700"}
        titleFontSize={"16px"}
        titleLineHeight={"20px"}
        titleColor={"#333333"}
        message={i18n("Integration.DontCloseOrReloadPage")}
        messageWidth={"320px"}
        messageHeight={"44px"}
        messageFontSize={"16px"}
        messageFontWeight={"400"}
        messageLineHeight={"21.79px"}
        messageColor={"#333333"}
        primaryLabel={i18n("SubscriptionModals.CANCEL")}
        primaryAction={() => setShowWaitModal(false)}
        primaryLabelWidth={"55px"}
        primaryLabelHeight={"20px"}
        primaryLabelFontWeight={"700"}
        primaryLabelFontSize={"14px"}
        primaryLabelLineHeight={"20px"}
        primaryLabelColor={"#828282"}
        isCenteredOnMobile
      />
    </>
  );
};

export default InvoiceFilterPage;
